<template>   
    <v-container>

        <v-flex xs12 sm6>
            <span style="font-size:14px;">{{label}}</span>
            <span v-if="value === undefined && this.required == true" class="caption error--text"> (Verplicht veld)</span>
        </v-flex>

        <v-flex xs12 sm5 offset-sm1>
            <v-layout row justify-center="">
                <v-btn small class="btn-left"  @click='updateValue(true)' :class="{'success' : value == true}" >Ja</v-btn>
                <v-btn small class="btn-right" @click='updateValue(false)' :class="{'error'   : value == false}">Nee</v-btn>
            </v-layout>
        </v-flex>

    </v-container>

</template>

<script>
export default {
  props: ["value", "label", "field", "required"],
  methods: {
    updateValue(val) {
      this.$emit("input", val);
      this.$emit("update:error", true);
    }
  }
};
</script>

<style scoped>
.btn-left {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.btn-right {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
</style>

